import { useLang } from "@/providers/langProvider";
import { useCallback } from "react";

export const useRemoveLangFromPath = () => {
  const lang = useLang();
  // Stable across renders (only re-created when `lang` changes) so callers can
  // safely use it as a useMemo/useCallback dependency without busting the memo.
  const removeLangFromPath = useCallback(
    (pathname: string, all = false) => {
      let currPath = pathname;
      const pathLang = "/" + lang;
      if (currPath.startsWith(pathLang))
        currPath = currPath.replace(pathLang, "");
      if (all) {
        currPath = currPath.replace("/ar", "").replace("/en", "");
      }
      if (currPath === "") currPath = "/";
      return currPath;
    },
    [lang],
  );
  return removeLangFromPath;
};
